import { render, staticRenderFns } from "./ComponenteCertificadoDigitalCadastro.vue?vue&type=template&id=fd0aeb4c&class=componenteCertificadoCadastro&"
import script from "./ComponenteCertificadoDigitalCadastro.vue?vue&type=script&lang=js&"
export * from "./ComponenteCertificadoDigitalCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ComponenteCertificadoDigitalCadastro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports